<script>
import axios from "axios";
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import FormAdmin from "./adminUser/form-admin.vue";
import FormEmpresa from "./adminUser/form-empresa.vue";
import FormNegocio from "./adminUser/form-negocio.vue";
import FormCapturista from "./adminUser/form-capturista.vue";
import FormMunicipio from "./adminUser/form-municipios.vue";
import FormGerente from "./adminUser/form-getente.vue";

import { todoMethods } from "@/state/helpers";

import { tableData } from "./dataAdvancedtable";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Nuevo Usuario Admin",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    FormAdmin,
    FormEmpresa,
    FormNegocio,
    FormCapturista,
    FormMunicipio,
    FormGerente,
  },
  data() {
    return {
      checked: true,
      checked1: true,
      label: "",
      active: 1,
      dataOn: "On",
      dataOff: "Off",

      // ************************************** Link
      tableData: tableData,
      title: "Información de Usuario Admin",
      items: [
        {
          text: "Usuario Admin",
          href: "/UsuariosAdmin",
        },
        {
          text: "Información Usuario Admin",
          active: true,
        },
      ],
      showModal: false,
      isLoading: false,
      fullPage: true,
      canCancel: false,
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      todocurrentPage: 1,
      perPage: 10,
      todoperPage: 10,
      pageOptions: [10, 25, 50, 100],
      todoOptions: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortBy: "age",
      sortDesc: false,
      useSlot: false,
      loader: "spinner",
      color: "#007bff",
      bgColor: "#FFFFFF",
      height: 128,
      width: 128,
      timeout: 3000, //ms
      fetchingStats: true,
      earningStatus: true,
      usuarioNegocio: "",
      usuarioAdmin: "",
      usuarioEmpresa: "",
      usuarioPunto: "",
      objeto: {
        email: "",
        nombre: "",
        password: "",
      },
      tipoUser: "",
      tipos: [
        { tipo: "Administrador", id_tipo: 1 },
        { tipo: "Empresa, institucion o dependencia", id_tipo: 2 },
        { tipo: "Punto de Venta", id_tipo: 3 },
        { tipo: "Capturista", id_tipo: 4 },
        { tipo: "Municipio", id_tipo: 6 },
        { tipo: "Gerente", id_tipo: 7 },
        { tipo: "Admin Municipio", id_tipo: 8 },
      ],
    };
  },

  computed: {
    permit() {
      // give me the value of permit in permits local storage
      const permits = JSON.parse(localStorage.getItem("permits"));
      if (permits.permit === "admin") return 1;
      else if (permits.permit === "empresa") return 2;
      else if (permits.permit === "negocio") return 3;
      else if (permits.permit === "punto") return 4;
      else if (permits.permit === "municipio") return 6;
      else if (permits.permit === "gerente") return 7;
      else if (permits.permit === "admin_municipio") return 8;
      else return 0;
    },
    opcionesTipoUsuario() {
      return this.permit == 7 ? [{tipo: "Negocio", id_tipo: 3}] : this.tipos 
    },
    getNegocio() {
      const usuario = JSON.parse(localStorage.getItem("user"));
      return usuario.id_negocio
    }
  },

  mounted() {
    this.checked = Boolean(this.active);
    if(this.permit == 7) this.objeto.id_negocio = this.getNegocio;
  },

  methods: {
    update() {
      this.label = this.checked ? this.dataOn : this.dataOff;
    },
    ...todoMethods,
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    todoFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.todoTotalRows = filteredItems.length;
      this.todocurrentPage = 1;
    },

    getColor(estado) {
      if (estado == "Activo") return "red";
      else return "green";
    },

    handleInput(value, data) {
      this.editableDataItems[data.index][data.field.key] = value;
    },

    handleSubmit() {
      axios
        .post("/register", this.objeto)
        .then((res) => {
          const { response = "" } = res.data;
          if (response) {
            this.$swal("Registro", "Usuario creado correctament", "success");
            this.$router.push({
              name: "UsuariosAdmin",
            });
          } else {
            this.$swal("Alerta", "No se pudo crear", "warninig");
          }
        })
        .catch((err) => {
          const { response = "", details = "" } = err.response.data;
          if (response === false) {
            this.$swal("Error", `${details}`, "warning");
          } else {
            this.$swal("Error", "Ocurrio un error", "error");
          }
        });
    },
    handleChange() {
      this.tipoUser = "";
      const tip = this.objeto.id_tipo;
      if (tip === 1) {
        this.tipoUser = "admin";
      }
      if (tip === 2) {
        this.tipoUser = "empresa";
      }
      if (tip === 3) {
        this.tipoUser = "negocio";
      }
      if (tip === 4) {
        this.tipoUser = "capturista";
      }
      if (tip === 6) {
        this.tipoUser = "municipio";
      }
      if (tip === 7) {
        this.tipoUser = "gerente";
      }
      if (tip === 8) {
        this.tipoUser = "admin_municipio";
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
        <v-card>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-4">
                <b><label class="form-check-label">Tipo de usuario</label></b>
                <div class="mb-4">
                  <b-form-select
                    class="form-select"
                    v-model="objeto.id_tipo"
                    size="lg"
                    @change="handleChange()"
                  >
                    <option
                      v-for="tipo in opcionesTipoUsuario"
                      :key="tipo.tipo"
                      :value="tipo.id_tipo"
                    >
                      {{ tipo.tipo }}
                    </option>
                  </b-form-select>
                </div>
              </div>
            </div>

            <FormAdmin :objeto="objeto" v-if="tipoUser === 'admin'" />
            <FormEmpresa :objeto="objeto" v-if="tipoUser === 'empresa'" />
            <FormNegocio :objeto="objeto" v-if="tipoUser === 'negocio'" />
            <FormCapturista :objeto="objeto" v-if="tipoUser === 'capturista'" />
            <FormMunicipio :objeto="objeto" v-if="tipoUser === 'municipio'" />
            <FormGerente :objeto="objeto" v-if="tipoUser === 'gerente'" />
            <FormMunicipio :objeto="objeto" v-if="tipoUser === 'admin_municipio'" />

            <div class="row mt-4">
              <v-row>
                <v-col md="12">
                  <v-btn
                    color="primary"
                    type="button"
                    v-on:click="handleSubmit()"
                  >
                    Guardar
                  </v-btn>
                  <v-divider class="mx-1" inset vertical></v-divider>
                  <router-link to="/UsuariosAdmin">
                    <v-btn color="error" type="button"> Cancelar </v-btn>
                  </router-link>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss">
$default: black;
$active: #2dc772;
$inactive: #6c757d;
$text: #9d9d9d;
$text-hover: white;
$size: 0.7rem;
$w: 60px;
$h: 25px;
$circle: $h - 4;
$toggle-dis: $w - $circle - 2;

.switch {
  position: relative;
  display: inline-block;
  width: $w;
  height: $h;
  border-radius: 100px;

  .circle {
    display: flex;
    align-items: center;
    width: 100%;
    height: $h - 1;
    border-radius: 100px;
    background-color: $default;

    & > span {
      font-size: $size;
      color: $text;
      padding-left: $h + -6;
    }

    &::before {
      position: absolute;
      content: "";
      height: $circle;
      width: $circle;
      left: 1px;
      top: 1px;
      border-radius: 100px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    &:hover {
      background-color: lighten($default, 20);

      & > span {
        color: $text-hover;
      }
    }
  }

  .circle-on {
    background-color: $active;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $active solid;

      &::before {
        background-color: $active;
      }

      & > span {
        color: $active;
      }
    }
  }

  .circle-off {
    background-color: $inactive;

    & > span {
      color: white;
    }

    &:hover {
      background-color: white;
      border: 1px $inactive solid;

      &::before {
        background-color: $inactive;
      }

      & > span {
        color: $inactive;
      }
    }
  }

  & input {
    display: none;

    &:checked + .circle:before {
      -webkit-transform: translateX($toggle-dis);
      -ms-transform: translateX($toggle-dis);
      transform: translateX($toggle-dis);
    }
  }
}
</style>